import React, { useState } from 'react';
import ReactDatePicker from 'react-datepicker';

const range = (start, end) => {
    let m = [];
    for (let i = start; i <= end; i++)
        m.push(i);
    return m.reverse();
}

const getYear = (date) => date.getFullYear();
const getMonth = (date) => date.getMonth();


const BirthDateControl = ({ field='',label, type = 'text',id, placeholder='', value='', onChange=()=>'',readOnly=false,minDate=null,maxDate=null}) => {

    const years = range(getYear(new Date())-80, getYear(new Date()) -10);
    const months = [
        "Enero",
        "Febrero",
        "Marzo",
        "Abril",
        "Mayo",
        "Junio",
        "Julio",
        "Agosto",
        "Septiembre",
        "Octubre",
        "Noviembre",
        "Diciembre",
    ];


    const internalOnchange=()=>{

    }


    return (
        <div className="sg-input mt-15">
        <label htmlFor={id}>{label}</label>
        <ReactDatePicker
            renderCustomHeader={({
                date,
                changeYear,
                changeMonth,
                decreaseMonth,
                increaseMonth,
                prevMonthButtonDisabled,
                nextMonthButtonDisabled,
            }) => (
                <div
                    style={{
                        margin: 10,
                        display: "flex",
                        justifyContent: "center",
                    }}
                >
                    <button onClick={decreaseMonth} disabled={prevMonthButtonDisabled}>
                        {"<"}
                    </button>
                    <select
                        value={getYear(date)}
                        onChange={({ target: { value } }) => changeYear(value)}
                    >
                        {years.map((option) => (
                            <option key={option} value={option}>
                                {option}
                            </option>
                        ))}
                    </select>

                    <select
                        value={months[getMonth(date)]}
                        onChange={({ target: { value } }) =>
                            changeMonth(months.indexOf(value))
                        }
                    >
                        {months.map((option) => (
                            <option key={option} value={option}>
                                {option}
                            </option>
                        ))}
                    </select>

                    <button onClick={increaseMonth} disabled={nextMonthButtonDisabled}>
                        {">"}
                    </button>
                </div>
            )}
           
            className="date-vsp" locale="es" selected={value} onChange={onChange} dateFormat='dd/MM/yyyy' readOnly={readOnly} minDate={minDate} maxDate={maxDate}
        />           
    </div>
        
    );
}

export default BirthDateControl;
